import { NgClass, NgFor, NgIf, NgSwitch, NgSwitchCase, NgSwitchDefault } from '@angular/common';
import { Component } from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import { MatIconModule } from '@angular/material/icon';
import { MatMenuModule } from '@angular/material/menu';
import { MatTooltipModule } from '@angular/material/tooltip';
import { FieldType } from '@ngx-formly/core';

/**
 * FormlyMatButtonComponent
 * @Prop onClick: (event: any, field: FormlyFieldConfig) => void - Function to execute when the button is clicked. Receives the click event and the Formly field configuration as arguments.
 * @Prop matButtonName: string - The name of the Angular Material button type to apply (e.g., 'mat-raised-button', 'mat-stroked-button', etc.).
 * @Prop buttonClassArray: string[] - An array of additional CSS classes to apply to the button for custom styling.
 * @Prop icon: string - The name of the Material icon to display on the button.
 * @Prop disabled: boolean - A flag to indicate whether the button should be disabled.
 * @Prop indicateMenuWithArrowDownIcon: boolean - A flag to indicate whether to include a downward arrow icon on the button (used for menu buttons).
 * @Prop menuItems: FormComponentActionButtons[] - An array of action buttons to display in a menu when the button is clicked. Each button should have a label and an onClick function.
 */

@Component({
	selector: 'formly-mat-button',
	templateUrl: './formly-mat-button.component.html',
	styleUrls: ['./formly-mat-button.component.less'],
	standalone: true,
	imports: [NgSwitch, NgSwitchCase, MatButtonModule, MatMenuModule, NgClass, MatIconModule, NgSwitchDefault, NgIf, NgFor, MatTooltipModule],
})
export class FormlyMatButtonComponent extends FieldType {
	onClick($event) {
		if (this.props.onClick) {
			this.props.onClick($event, this.field);
		}
	}
}

export const formlyMatButtonNames = {
	MatRaisedButton: 'mat-raised-button',
	MatStrokedButton: 'mat-stroked-button',
	MatFlatButton: 'mat-flat-button',
	MatIconButton: 'mat-icon-button',
	MatButton: 'mat-button',
	MatMenuButton: 'mat-menu-button',
};
